module.exports = __webpack_public_path__ + "static/img/model2@2x.2ebc76f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/model2@2x.png
// module id = bwWz
// module chunks = 1